module.exports = __webpack_public_path__ + "static/media/Loading.a8d3121b.gif";